<template>
	<v-app>
		<!-- Log out modal -->
		<v-dialog v-model="isSureToDeletelogout" width="443" persistent>
			<v-card>
				<div class="d-flex flex-column pa-5 mx-auto">
					<h6 class="text--secondary text-center text-h6 font-weight-bold mb-4">
						Are you sure want to logout? If you logout from the app, then you cart details are gone!
					</h6>

					<div class="d-flex align-center justify-center">
						<v-btn
							large
							rounded
							outlined
							type="button"
							color="primary"
							class="ma-2"
							@click="isSureToDeletelogout = false"
							>No</v-btn
						>
						<v-btn
							large
							rounded
							type="button"
							color="primary"
							class="ma-2"
							@click="
								isSureToDeletelogout = false
								logout()
							"
							>Yes</v-btn
						>
					</div>
				</div>
			</v-card>
		</v-dialog>
		<div class="header--border">
			<v-toolbar class="container fixed" dark color="secondary" style="flex: none">
				<v-toolbar-title class="white--text">
					<div class="mamae">
						<a href="https://nsquareherbal.co.uk/"
							><img class="logo" src="/assets/image/logo.svg"
						/></a>
					</div>
				</v-toolbar-title>

				<div class="hidden-sm-and-down px-4">
					<v-btn :to="{ name: 'Product' }" depressed color="secondary" class="black--text"
						>Products</v-btn
					>
					<v-btn :to="{ name: 'Goal' }" depressed color="secondary" class="black--text"
						>Goals</v-btn
					>
					<v-btn :to="{ name: 'Order' }" depressed color="secondary" class="black--text"
						>Orders</v-btn
					>
					<v-btn
						target="_blank"
						href="https://nsquareherbal.co.uk/about-us"
						depressed
						color="secondary"
						class="black--text"
						>About Us</v-btn
					>
					<v-btn
						target="_blank"
						href="https://nsquareherbal.co.uk/contact"
						depressed
						color="secondary"
						class="black--text"
						>Contact Us</v-btn
					>
				</div>

				<v-spacer></v-spacer>

				<v-layout class="align-center justify-end hidden-sm-and-down">
					<div class="relative mr-2">
						<v-btn small outlined fab color="primary" :to="{ name: 'cart' }">
							<v-icon color="primary">mdi-cart</v-icon>
						</v-btn>
						<span v-if="cartProducts.length > 0" class="cart__products-badge">{{
							cartProducts.length
						}}</span>
					</div>
					<v-menu v-if="1" offset-y left>
						<template v-slot:activator="{ on, attrs }">
							<v-btn v-bind="attrs" v-if="isLogin" v-on="on" rounded color="primary" dark large
								><img class="logo mr-2" src="/assets/image/Profile.png" />{{ userName }}
								<img v-if="isLogin" class="logo" src="/assets/image/arrow_drop_down.png" />
							</v-btn>
							<v-btn v-else rounded color="primary" :to="`/change-password`" dark large
								>Sign In
							</v-btn>
						</template>

						<v-list>
							<v-list-item :to="{ name: 'profile' }">
								<img class="logo mr-2" src="/assets/image/Profile.svg" />
								<v-list-item-title>Profile</v-list-item-title>
							</v-list-item>

							<v-list-item :to="`/change-password`">
								<img class="logo mr-2" src="/assets/image/Lock.svg" />
								<v-list-item-title>Change Password</v-list-item-title>
							</v-list-item>

							<v-list-item @click="checkCartProduct">
								<img class="logo mr-2" src="/assets/image/Logout.svg" />
								<v-list-item-title>Logout</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
					<v-btn v-else rounded color="primary" dark large
						><img class="logo mr-2" src="/assets/image/Profile.png" />Sign In</v-btn
					>
				</v-layout>
				<v-layout class="align-center justify-end hidden-md-and-up">
					<div class="relative mr-2">
						<v-btn small outlined fab color="primary" :to="{ name: 'cart' }">
							<v-icon color="primary">mdi-cart</v-icon>
						</v-btn>
						<span v-if="cartProducts.length > 0" class="cart__products-badge">{{
							cartProducts.length
						}}</span>
					</div>
					<v-menu class="icon" offset-y>
						<template v-slot:activator="{ on, attrs }">
							<v-app-bar-nav-icon dark v-bind="attrs" v-on="on"></v-app-bar-nav-icon>
						</template>

						<v-list>
							<v-list-item :to="{ name: 'Product' }">
								<v-list-item-title class="py-2">Products</v-list-item-title>
							</v-list-item>
							<v-list-item :to="{ name: 'Goal' }">
								<v-list-item-title class="py-2">Goals</v-list-item-title>
							</v-list-item>
							<v-list-item :to="{ name: 'Order' }">
								<v-list-item-title class="py-2">Orders</v-list-item-title>
							</v-list-item>
							<v-list-item target="_blank" href="https://nsquareherbal.co.uk/about-us">
								<v-list-item-title class="py-2">About Us</v-list-item-title>
							</v-list-item>
							<v-list-item target="_blank" href="https://nsquareherbal.co.uk/contact">
								<v-list-item-title class="py-2">Contact Us</v-list-item-title>
							</v-list-item>

							<v-list-item @click="isSureToDeletelogout = true">
								<v-list-item-title class="py-2">Log out</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</v-layout>
			</v-toolbar>
		</div>
	</v-app>
</template>

<script>
export default {
	data() {
		return {
			isLogin: false,
			userName: '',
			isSureToDeletelogout: false,
		}
	},
	mounted() {
		this.isLogin = localStorage.getItem('isLogin')
		if (this.isLogin) {
			this.userName = this.$store.getters.getUserName
		}
		this.$root.$on('isLogin', (msg, name) => {
			this.isLogin = msg
			this.userName = name
		})
	},
	computed: {
		cartProducts() {
			return this.$store.state.cartProducts
		},
	},
	methods: {
		logout() {
			this.$store.commit('resetCart')
			this.$store.commit('setUser', '')
			localStorage.removeItem('isLogin')
			this.$store.commit('RESET_VOUCHER_CODE_ID')
		    this.$store.commit('RESET_VOUCHER_CODE')
			this.isLogin = false
			this.$router.push('/')
		},
		checkCartProduct() {
			if (this.cartProducts.length > 0) {
				this.isSureToDeletelogout = true
			} else {
				this.isSureToDeletelogout = false
				this.logout()
			}
		},
	},
}
</script>

<style scoped>
.icon.v-menu__content {
	left: 0px !important;
	min-width: 100% !important;
}
.v-btn--active {
	color: green !important;
}
.relative {
	position: relative;
}
.cart__products-badge {
	position: absolute;
	top: -4px;
	right: -4px;
	z-index: 2;
	height: 20px;
	width: 20px;
	padding: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 700;
	line-height: normal;
	font-size: 0.87rem;
	background: #ffb800;
	border: 1px solid #ffffff;
	border-radius: 50%;
}
</style>